import React from "react";

import { useNavigate } from "react-router-dom";

import storage from "commons/utils/storage";

function Logout() {
    const navigate = useNavigate();

    React.useEffect(() => {
        storage.removeAll();

        navigate("/auth/login");
    }, [navigate]);

    return null;
}

export default Logout;
